document.addEventListener("DOMContentLoaded", function () {
  let loading = false;
  let currentPage = 1;

  function getNextPageUrl() {
    const pagination = document.querySelector(".pagination");
    if (!pagination) return null;

    const nextLink = pagination.querySelector(".next a");
    if (nextLink) return nextLink.getAttribute("href");

    // fallback: find page=currentPage+1
    const links = pagination.querySelectorAll("a");
    for (let link of links) {
      const url = new URL(link.href, window.location.origin);
      if (parseInt(url.searchParams.get("page")) === currentPage + 1) {
        return link.href;
      }
    }

    return null;
  }

  function loadMoreProducts() {
    if (loading) return;

    const nextPageUrl = getNextPageUrl();
    if (!nextPageUrl) return; // 🚫 STOP when no next page

    loading = true;
    const loader = document.getElementById("infinite-loader");
    if (loader) loader.style.display = "block";

    fetch(nextPageUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelectorAll("#product-grid > *");
        if (!newProducts.length) {
          loading = false;
          return;
        }

        const grid = document.querySelector("#product-grid");
        newProducts.forEach(item => grid.appendChild(item));

        const newPagination = doc.querySelector(".pagination");
        const oldPagination = document.querySelector(".pagination");

        if (oldPagination && newPagination) {
          oldPagination.innerHTML = newPagination.innerHTML;
        }

        currentPage++; // ✅ IMPORTANT
        loading = false;
        if (loader) loader.style.display = "none";
      })
      .catch(() => {
        loading = false;
        if (loader) loader.style.display = "none";
      });
  }

  window.addEventListener("scroll", function () {
    const scrollPoint = window.innerHeight + window.scrollY;
    const triggerPoint = document.body.offsetHeight - 300;

    if (scrollPoint >= triggerPoint) {
      loadMoreProducts();
    }
  });
});
